var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58,
    height: 40,
    viewBox: "0 0 58 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_181",
    "data-name": "Ret\\xE2ngulo 181",
    width: 58,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "amex",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "amex-2",
    "data-name": "amex"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_196",
    "data-name": "Ret\\xE2ngulo 196",
    stroke: "#e7e7e7",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 40,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "M132.895,261.287h2.938v-6.828h-3.2v.95l-.6-.95h-2.766v1.21l-.518-1.21h-5.1c-.172,0-.346.086-.518.086s-.26.086-.432.172-.26.086-.432.172v-.432h-14.6l-.432,1.124-.432-1.124h-3.458v1.21l-.518-1.21h-2.778l-1.21,2.938v3.89h1.988l.346-.95h.692l.346.95h15.212v-.864l.6.864h4.236v-.518c.086.086.26.086.346.172s.26.086.346.172a1.1,1.1,0,0,0,.518.086h3.112l.346-.95h.692l.346.95H132.2v-.854Zm4.754,8.644v-6.388h-23.77l-.6.864-.6-.864h-6.918v6.828h6.914l.6-.864.6.864H118.2V268.9h-.172a4.186,4.186,0,0,0,1.556-.26v1.816h3.112v-.864l.6.864h12.878a7.363,7.363,0,0,0,1.47-.518Z",
    transform: "translate(-89.243 -242.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    d: "M136.177,281.713h-2.334v.95h2.248a1.43,1.43,0,0,0,1.556-1.47,1.2,1.2,0,0,0-1.382-1.3h-1.038a.432.432,0,1,1,0-.864h1.988l.432-.95h-2.334a1.414,1.414,0,0,0-1.556,1.382,1.2,1.2,0,0,0,1.382,1.3h1.038a.4.4,0,0,1,.432.432c.086.346-.086.518-.432.518Zm-4.236,0h-2.334v.95h2.248a1.43,1.43,0,0,0,1.556-1.47,1.2,1.2,0,0,0-1.382-1.3h-1.038a.432.432,0,1,1,0-.864h1.988l.432-.95h-2.334a1.414,1.414,0,0,0-1.556,1.382,1.2,1.2,0,0,0,1.382,1.3h1.038a.475.475,0,1,1,0,.95Zm-3.026-2.766V278h-3.63v4.582h3.63v-.95h-2.6v-.95h2.506v-.95h-2.506v-.864h2.6Zm-5.878,0c.432,0,.6.26.6.518s-.172.518-.6.518h-1.3v-1.124Zm-1.3,1.988h.518l1.382,1.642h1.3l-1.556-1.728a1.386,1.386,0,0,0,1.21-1.382,1.43,1.43,0,0,0-1.556-1.47h-2.42v4.582h1.038Zm-2.766-1.382a.546.546,0,0,1-.6.6h-1.382v-1.21h1.3a.616.616,0,0,1,.688.61ZM115.961,278v4.582H117v-1.556h1.382a1.522,1.522,0,0,0,1.642-1.556,1.5,1.5,0,0,0-1.556-1.556Zm-1.556,4.582h1.3l-1.816-2.334L115.7,278h-1.3l-1.124,1.47L112.157,278h-1.3l1.816,2.248-1.816,2.248h1.3l1.124-1.47Zm-3.89-3.63V278h-3.63v4.582h3.63v-.95h-2.6v-.95h2.506v-.95h-2.506v-.864h2.6Zm21-8.124,1.816,2.766h1.3V269h-1.038v3.026l-.26-.432-1.642-2.6h-1.382v4.582h1.038v-3.112Zm-4.494-.086.346-.95.346.95.432,1.038h-1.556Zm1.816,2.852h1.124l-2-4.594h-1.382l-1.988,4.582h1.124l.432-.95h2.248Zm-4.84,0,.432-.95h-.26a1.16,1.16,0,0,1-1.21-1.3v-.086a1.16,1.16,0,0,1,1.21-1.3h1.124V269h-1.21a2.064,2.064,0,0,0-2.16,2.248v.086A2,2,0,0,0,124,273.585Zm-3.89,0h1.038V269.1h-1.038Zm-2.248-3.63c.432,0,.6.26.6.518s-.172.518-.6.518h-1.3v-1.124Zm-1.3,1.988h.518l1.382,1.642h1.3l-1.556-1.728a1.386,1.386,0,0,0,1.21-1.382,1.43,1.43,0,0,0-1.556-1.47h-2.42V273.6h1.038Zm-1.9-1.988V269h-3.63v4.582h3.63v-.95h-2.6v-.95h2.5v-.95h-2.506v-.864h2.6ZM106.8,273.6h.95l1.3-3.716V273.6h1.038V269h-1.728l-1.038,3.112L106.271,269h-1.728v4.582h1.038v-3.716Zm-5.618-2.852.346-.95.346.95.432,1.038h-1.556Zm1.816,2.852h1.124L102.123,269h-1.3l-1.988,4.582h1.122l.432-.95h2.248Z",
    transform: "translate(-89.243 -255.879)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.8188ed4523745cf8099fa55647f5b130.svg";
export { ForwardRef as ReactComponent };